import React from 'react';
import Button from './Button';
import Card from './Card';

interface EventModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function EventModal({
  isOpen,
  onClose,
  title,
  children,
  actions
}: EventModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-ink/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <Card className="relative w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold text-ink">{title}</h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="p-2 rounded-full"
            >
              ×
            </Button>
          </div>
          
          {/* Content */}
          <div className="mb-6">
            {children}
          </div>
          
          {/* Actions */}
          {actions && (
            <div className="flex justify-end gap-3">
              {actions}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
} 